module.exports = __webpack_public_path__ + "static/media/silver-medal.93d4e6d3.svg";